import { jsx as _jsx } from "react/jsx-runtime";
import * as Ariakit from '@ariakit/react';
import { useCallback } from 'react';
import * as Styles from './styles';
export const HeartButton = function HeartButton({ disabled, 'aria-disabled': ariaDisabled, filled, as, onClick, ref, ...rest }) {
    const callbackRef = useCallback((node) => {
        if (!node)
            return;
        if (ref)
            ref.current = node;
        node.style.animationName = 'none';
    }, [ref]);
    const handleClick = e => {
        const { currentTarget } = e;
        currentTarget.style.animationName = 'none';
        requestAnimationFrame(() => {
            setTimeout(() => {
                currentTarget.style.animationName = '';
                onClick?.(e);
            }, 0);
        });
    };
    return (_jsx(Ariakit.Focusable, { accessibleWhenDisabled: true, disabled: ariaDisabled ?? disabled, render: _jsx(Styles.Button, { ref: callbackRef, as: as ?? 'button', onClick: handleClick, ...rest }), children: _jsx(Styles.Icon, { width: '100%', renderFillPath: _jsx(Styles.IconFill, { "$filled": filled }) }) }));
};
//# sourceMappingURL=index.js.map